import { Box, styled } from '@mui/material';

import { ChartPalette } from 'components/charts/types/chart-palette.type';

// The shared card frame for ChartCard and KpiCard. Extend it with styled(ChartFrame) for gap and sizing.
export const ChartFrame = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'chartPalette' && prop !== 'animationDuration',
})<{ chartPalette: ChartPalette; animationDuration: number }>(({ theme, chartPalette, animationDuration }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: theme.spacing(5),
  backgroundColor: chartPalette.backgrounds.surface,
  border: `1px solid ${chartPalette.borders.subtle}`,
  borderRadius: 16,
  boxShadow: chartPalette.shadow,
  transition: `border-color ${animationDuration}ms ${theme.transitions.easing.easeInOut}`,

  '&:hover': {
    borderColor: chartPalette.borders.strong,
  },
}));
